/* eslint-disable jira/filename-case */
export const PACKAGE_NAME =
	'@jira/navigation-apps__sidebar-nav4-sidebars-content-projects-jsw-project-menu';
export const TEAM_NAME = 'jira-cosmos';

export const NO_OF_BOARDS_TO_FETCH = 25;
export const NO_OF_ADDITIONAL_BOARDS_TO_SHOW = 5;
